// extracted by mini-css-extract-plugin
module.exports = {"trigger":"oTagQuickOptions_trigger__6tdva","menu":"oTagQuickOptions_menu__ogPZp"};